import type { IconData } from '@stacksjs/iconify-core'

export const poolLadder: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M45 45c-1.89 0-3.78-.556-5.42-1.67a2.86 2.86 0 0 0-3.16 0A9.64 9.64 0 0 1 31 45c-1.89 0-3.78-.556-5.42-1.67a2.86 2.86 0 0 0-3.16 0A9.64 9.64 0 0 1 17 45c-1.89 0-3.78-.556-5.42-1.67a2.86 2.86 0 0 0-3.16 0A9.64 9.64 0 0 1 3 45m37-12H20m20-11H20m0 16.5v-27a8.5 8.5 0 0 0-17 0v1.955c0 .947.545 1.824 1.481 1.968a6.7 6.7 0 0 0 2.038 0C7.455 15.279 8 14.402 8 13.455V11.5a3.5 3.5 0 1 1 7 0v28m30 .5V11.5a8.5 8.5 0 0 0-17 0v1.955c0 .947.545 1.824 1.481 1.968a6.7 6.7 0 0 0 2.038 0c.936-.144 1.481-1.021 1.481-1.968V11.5a3.5 3.5 0 1 1 7 0V38\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default poolLadder
